var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWorldMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 14.714v-3.428M12 17V9m1 7v-6m-2 6v-6m4 4.714v-3.428M16 14v-2m-8 2v-2m9 1.5v-1.071M7 13.5v-1.071M14.02 15L14 11m-4 4v-4m8 1.715v.598m-12-.598v.598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 12c0-1.484 3.582-2.688 8-2.688s8 1.204 8 2.688",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.925 13C4.725 12.732 4 12.382 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12c0 .377-.649.725-1.737 1"
  }))));
}

export default SvgIconWorldMap;